module.exports = __webpack_public_path__ + "img/hezuo.0374d364.png";